// KIV ("keep in view") is where every idea starts: only the author and moderators see it, and it is
// the only status an author may still edit or delete in. Moderators then accept or close it.
export const IDEA_STATUSES = {
  KIV: 'kiv',
  ACCEPTED: 'accepted',
  CLOSED: 'closed',
} as const;

export type IdeaStatus = (typeof IDEA_STATUSES)[keyof typeof IDEA_STATUSES];

export const IDEA_STATUS_VALUES = Object.values(IDEA_STATUSES) as [IdeaStatus, ...IdeaStatus[]];

// The one place the values get their wording: tags, filters, statistics and history.
export const IDEA_STATUS_LABELS: Record<IdeaStatus, string> = {
  [IDEA_STATUSES.KIV]: 'KIV',
  [IDEA_STATUSES.ACCEPTED]: 'Accepted',
  [IDEA_STATUSES.CLOSED]: 'Closed',
};

const TRANSITIONS: Record<IdeaStatus, readonly IdeaStatus[]> = {
  [IDEA_STATUSES.KIV]: [IDEA_STATUSES.ACCEPTED, IDEA_STATUSES.CLOSED],
  [IDEA_STATUSES.ACCEPTED]: [],
  [IDEA_STATUSES.CLOSED]: [],
};

export const ALLOWED_TRANSITIONS: Readonly<Record<IdeaStatus, readonly IdeaStatus[]>> = Object.freeze(TRANSITIONS);

export const TERMINAL_STATUSES: readonly IdeaStatus[] = [IDEA_STATUSES.ACCEPTED, IDEA_STATUSES.CLOSED];

export function canTransition(from: IdeaStatus, to: IdeaStatus): boolean {
  return ALLOWED_TRANSITIONS[from].includes(to);
}

export function isClosed(status: IdeaStatus): boolean {
  return TERMINAL_STATUSES.includes(status);
}

export function nextStatuses(from: IdeaStatus): readonly IdeaStatus[] {
  return ALLOWED_TRANSITIONS[from];
}
